import React, { useEffect, useState } from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { css } from 'aphrodite';
import { Col, Row } from 'antd';
import { CardForm } from '../../common/card-form';
import TextBase from '../../common/text';
import { convertPxToRem, getCreditCardType, translate } from '../../helper';
import PageTitleHeader from '../../common/page-title-header';
import { Colors } from '../../themes/Colors';
import { SVGImageComponentReact } from '../../themes/Images';
import { styles } from './styles';

const VALUES = {
  card_holder: '',
  number: '',
  expiration_date: '',
  cvc: ''
};

export const AddPaymentMethodBase = ({ title, goBack }) => {
  const [values, setValues] = useState(VALUES);
  const [validation, setValidation] = useState({});
  const [brand, setBrand] = useState('');

  useEffect(() => {
    handleSetBrand();
  }, [values.number]);

  const handleSetBrand = () => {
    if (values.number) {
      const newBrand = getCreditCardType(values.number);
      setBrand(newBrand || '');
    }
  };

  return (
    <div className={css(styles.container)}>
      <Row justify="space-between">
        <Col>
          <Row>
            <div
              style={{ marginRight: convertPxToRem(33) }}
              className="flex-row-center-center cursor-pointer"
              onClick={goBack}
            >
              <SVGImageComponentReact.IconArrowBack style={{width:"var(--fs-lg)", height:"var(--fs-lg)", color: '#1A5A78'}}/>
            </div>
            <PageTitleHeader
              title={translate(title)}
              showBar={false}
            />
          </Row>
        </Col>
      </Row>

      <Elements style={{ width: '100%', height: 100 }} stripe={loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)}
        options={{ mode: 'setup', currency: 'usd', amount: 0, paymentMethodTypes: ['card'] }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <div
            style={{
              width: '60%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              backgroundColor: 'white',
              padding: '32px',
              border: '1px solid rgba(128, 128, 128, 0.2)',
            }}
          >
            <CardForm values={values} setValues={setValues} validation={validation} brand={brand} setValidation={setValidation} goBack={goBack} />
          </div>
        </div>
      </Elements>
    </div>
  );
};

